var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "struc-tree-menu"
  }, [_c('STreeList', {
    attrs: {
      "data": _vm.data
    },
    on: {
      "changeSelect": _vm.onSelect
    }
  }), _c('AddManage', {
    attrs: {
      "visible": _vm.addManage.visible,
      "item": _vm.addManage.item
    },
    on: {
      "close": function ($event) {
        _vm.addManage.visible = false;
      },
      "update": _vm.update
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };